import { observable } from 'mobx';
import { runtime } from '../../runtime/Runtime';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { Devices } from '../Devices';

export class Keyboard {
  readonly parent: Devices;

  constructor(parent) {
    this.parent = parent;
  }

  isKeyPressed(key: string): boolean {
    if (runtime.isServerRuntime) {
      return false;
    }
    return runtime.solidBrowserRuntime.browserKeyboard.isKeyPressed(key);
  }

  @memoize
  get currentKeyDown() {
    if (runtime.isServerRuntime) {
      return observable.map<string, KeyboardEvent | undefined>();
    }
    return runtime.solidBrowserRuntime.browserKeyboard.currentKeyDown;
  }
}
